// Central image asset map — real Shaan Curry House photoshoot images,
// hosted locally under /app/frontend/public/images/site/ so we never depend
// on any external domain.
const U = "/images/site";

export const assets = {
  logo: `${U}/No-Background-Shaan.png`, // still using original — see below
  halal: `${U}/Halal-logo-1-1024x740.png`,
  dishes: [
    `${U}/1.png`,
    `${U}/2.png`,
    `${U}/3.png`,
    `${U}/4.png`,
    `${U}/5.png`,
    `${U}/Untitled-design-3.jpg`,
    `${U}/Untitled-design-4.jpg`,
    `${U}/Untitled-design-6.jpg`,
    `${U}/Untitled-design-11.jpg`,
  ],
  gallery: [
    `${U}/g1.jpg`,
    `${U}/g2.jpg`,
    `${U}/g3.jpg`,
    `${U}/g5.jpg`,
    `${U}/g8.jpg`,
    `${U}/g9.jpg`,
    `${U}/g10.jpg`,
    `${U}/g12.jpg`,
    `${U}/g13.jpg`,
    `${U}/g14.jpg`,
    `${U}/g17.jpg`,
    `${U}/g18.jpg`,
    `${U}/g19.jpg`,
    `${U}/g21.jpg`,
  ],
};

export const business = {
  name: "Shaan Curry House",
  since: "1995",
  address: "1489 Merivale Rd, Nepean, ON K2E 5P3",
  addressLine1: "1489 Merivale Rd,",
  addressLine2: "Nepean, ON K2E 5P3",
  phone: "+1 (613) 228-9759",
  phoneRaw: "+16132289759",
  orderOnline: "https://order.cpos.com/web/Shaan_Curry_House/main",
  orderInHouse: "https://order.cpos.com/web/Shaan_Curry_House/main",
  orderUberEats: "https://www.ubereats.com/ca/store/shaan-curry-house/cBHmbTBkXjaTrW0S6-ivcQ?srsltid=AfmBOopN55RiX56oVRuYMCn7ZAIeVXuFfWQxoegWwvAbhnnC5pkHEMis",
  orderSkip: "https://www.skipthedishes.com/shaan-curry-house-merivale",
  whatsapp: "+1 (613) 413-1699",
  whatsappRaw: "16134131699",
  email: "shaancurryhouse@gmail.com",
  hours: "Mon – Sat: 11:30 AM – 8:00 PM",
  hoursShort: "Mon–Sat 11:30–8",
  instagram: "https://www.instagram.com/shaancurryhouseottawa/",
  facebook: "https://www.facebook.com/people/Shaan-Curry-House/100083295634619/",
  linkedin: "https://www.linkedin.com/company/shaancurryhouse/home/",
  tiktok: "https://www.tiktok.com/@shaanindianfoodresturant",
};
